import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-24 flex flex-col items-center justify-center text-center">
      <span className="text-7xl md:text-9xl font-black text-background-300 select-none">404</span>
      <h1 className="mt-4 text-xl md:text-2xl font-black text-foreground-950">
        页面不存在或已被移除
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
      <p className="mt-4 text-sm md:text-base text-foreground-600">
        你访问的页面可能已下线，不妨回到首页查看最新的今日黑榜与赛事资讯。
      </p>
      <div className="mt-7 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
        <Link
          to="/category/blacklist"
          className="px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看今日黑榜
        </Link>
      </div>
    </div>
  );
}